import { api } from "./client";
import type { AttendanceRecord, AttendanceSummaryRow } from "./types";

export const attendanceApi = {
  /** Per-employee totals for a window, including employees who never marked. */
  summary: (params: Record<string, unknown> = {}) =>
    api
      .get<AttendanceSummaryRow[]>("/attendance/summary/", { params })
      .then((r) => r.data),
  /** One employee's day-by-day record, including the days they were absent. */
  record: (employeeId: string, params: Record<string, unknown> = {}) =>
    api
      .get<AttendanceRecord>(`/attendance/record/${employeeId}/`, { params })
      .then((r) => r.data),
};
